import { queryKeyHolidayTypes, queryKeyPropertyTypes } from 'constants/url'

const ZERO_RESULT_FILTER_URL_KEYS = [queryKeyPropertyTypes, queryKeyHolidayTypes] as const

type ZeroResultFilterUrlUpdate = {
  paramName: string
  paramValue: string | undefined
}

export function getZeroResultFilterUrlUpdates(
  availableFilters: App.OfferListFilterOptions['filters'] | undefined,
  selectedFilters: App.OfferListFilters,
): Array<ZeroResultFilterUrlUpdate> {
  if (!availableFilters) return []

  const updates: Array<ZeroResultFilterUrlUpdate> = []

  for (const key of ZERO_RESULT_FILTER_URL_KEYS) {
    const available = availableFilters[key]
    if (!Array.isArray(available) || !available.length) continue

    const selected = selectedFilters[key]
    if (!Array.isArray(selected) || !selected.length) continue

    const liveCounts = new Map(available.map(f => [f.slug, f.count]))
    const valid = selected.filter(slug => (liveCounts.get(slug) ?? 0) > 0)

    if (valid.length !== selected.length) {
      updates.push({ paramName: key, paramValue: valid.length > 0 ? valid.join(',') : undefined })
    }
  }

  return updates
}
